/**
 * Created by Ivan on 04/06/2017.
 */
var axios = require('axios');
import config from './config/app';

var axiosInstance = axios.create({
    baseURL : config.baseUrl
});

export default axiosInstance;


// WEBPACK FOOTER //
// ./src/HttpRequest.js